import EventEmitter from 'events'

import { APIError } from '@providers/APIErrorProvider'

class ErrorEmitter extends EventEmitter {
  addError(err: APIError): void {
    this.emit('addError', err)
  }

  addErrors(apiErrors: APIError[]): void {
    this.emit('addErrors', apiErrors)
  }

  clearErrors(): void {
    this.emit('clearErrors')
  }
}

const errorEmitter = new ErrorEmitter()
export default errorEmitter
